<component-modal showClose="false">
  @if (isCreateFolderMode()) {
    <ng-container headerPrefix>
      @if (isCreateFolderMode()) {
        <button class="btn btn-icon" type="button" [disabled]="isProcessing()" (click)="setMode(Mode.Move)">
          <custom-icon class="d-flex align-items-center text-secondary" name="chevronLeft" size="16" viewBox="0 0 14 16" />
        </button>
      }
    </ng-container>
  }

  <ng-container title>{{ isCreateFolderMode() ? "New folder" : "Move document" }}</ng-container>

  <ng-container headerSuffix>
    <button class="btn btn-icon" type="button" [disabled]="isProcessing()" (click)="close()">
      <custom-icon name="close" class="text-secondary" [size]="20" />
    </button>
  </ng-container>

  <ng-container body>
    <div class="d-flex flex-column gap-3" [class.disabled]="isProcessing()">
      @switch (mode()) {
        @case (Mode.Move) {
          <ng-container [ngTemplateOutlet]="moveModeContent" />
        }
        @case (Mode.CreateFolder) {
          <ng-container [ngTemplateOutlet]="createFolderModeContent" />
        }
      }
    </div>
  </ng-container>

  <ng-container footer>
    <div class="grid-auto-cols flex-grow-1 gap-3">
      <button type="button" class="btn btn-lg btn-light" [disabled]="isProcessing()" (click)="close()">Cancel</button>

      <component-button-with-loading
        cssClass="btn btn-lg btn-primary"
        [isLoading]="isProcessing()"
        [disabled]="isProcessing() || (isCreateFolderMode() ? control.invalid : isMoveDisabled())"
        (click)="isCreateFolderMode() ? onCreateFolder() : onMove()">
        {{ isCreateFolderMode() ? "Create and Move" : "Move" }}
      </component-button-with-loading>
    </div>
  </ng-container>
</component-modal>

<ng-template #moveModeContent>
  <component-input
    [placeholder]="'Search folders'"
    [(ngModel)]="searchValue"
    [floating]="false"
    [secondary]="true"
    class="w-100"
    [isClearable]="true"
    [prefixIcon]="'searchIcon'" />

  <div class="divider-horizontal"></div>

  <div>
    <button class="btn btn-light btn-lg icon-with-text w-100 mb-2" (click)="setMode(Mode.CreateFolder)">
      <custom-icon name="plus" [size]="20" />
      <span>New Folder</span>
    </button>

    <div class="list" [class.loading-block]="isFetchingList()">
      @if (!foldersToDisplay().length && searchValue() && !isFetchingList()) {
        <div class="p-3 text-muted">No folders found for "{{ searchValue() }}"</div>
      }

      @for (folder of foldersToDisplay(); track folder.id) {
        <div class="list-item" [class.active]="folder.id === selectedFolder()?.id" (click)="selectedFolder.set(folder)">
          <custom-icon name="folder" [size]="20" viewBox="0 0 20 20" />
          <div class="list-item-title">
            <span class="text-truncate">{{ folder.name }}</span>

            @if (folder.isPublic) {
              <span class="badge badge-info">Public</span>
            }
          </div>

          @if (folder.id === document().folderId) {
            <span class="badge badge-primary">Current location</span>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #createFolderModeContent>
  <component-input
    label="Folder name"
    [formControl]="control"
    [isFocused]="true"
    [required]="true"
    [errorMessage]="control.hasError('required') && control.touched ? 'Folder name is required' : null"
    (enter)="onCreateFolder()" />
</ng-template>
